export default {
    ca: {
        title: 'Visor privat',
        message: 'Aquest visor està protegit amb contrasenya. Introduir la contrasenya',
        formValidation: 'El camp no pot estar buit',
        submitErrorMsg: 'Contrasenya incorrecta',
        passwordPlaceholder: 'Contrasenya',
        iniciaSessio: 'Desbloquejar',
    },
    es: {
        title: 'Visor privado',
        message: 'Este visor está protegido con contraseña. Introducir la contraseña',
        formValidation: 'El campo no puede estar vacío',
        submitErrorMsg: 'Contrasenya incorrecta',
        passwordPlaceholder: 'Contraseña',
        iniciaSessio: 'Desbloquear',
    },
    en: {
        title: 'Private viewer',
        message: 'This viewer is password protected. Enter the password',
        formValidation: 'The field can not be left empty',
        submitErrorMsg: 'Incorrect password',
        passwordPlaceholder: 'Password',
        iniciaSessio: 'Unlock',
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/password-modal/password-modal-translations.js